import React, { FC, useState } from "react"
import "../styles/smartlink.css"
import { Artist, Release } from "../../../../types"
import { KButton, KInput, KLogo, KSpan, KTitleSpan } from "kahuna-base-react-components"
import { releases } from "../../../../apis"
import { errorFilledToastOptions, successFilledToastOptions } from "../../../../constants"
import { toast } from "react-toastify"
import { SmartLinkPages } from "../ReleaseSmartLinkPage"
import { lang } from "../../../../constants/languages"

type CustomizeLinkProps = {
  release: Release
  setSelectedPage: (selectedPage: number) => void
  setSmartLinkExist: (smartLinkExist: boolean) => void
  linkText: string
  setLinkText: (linkText: string) => void
  selectedArtist?: string
}

const headerHeight = 88

const CustomizeLink: FC<CustomizeLinkProps> = (props) => {
  const { release, setSelectedPage, setSmartLinkExist, linkText, setLinkText, selectedArtist } = props

  const [loading, setLoading] = useState(false)

  const renderPill = (text: string) => {
    return (
      <div style={{ borderRadius: 4, backgroundColor: "#F5F5F5", padding: 4, paddingTop: 0 }} key={Math.random()}>
        <KSpan text={text} fontSize={11} fontWeight={500} lineHeight="12px" color="#111" letterSpacing="0.22px" />
      </div>
    )
  }

  const saveSmartLinkUrl = () => {
    if (linkText.includes("/")) {
      toast.error(lang.catalog.smart_link.error.url_slug_error, errorFilledToastOptions)
      return
    }

    setLoading(true)
    releases(`/release/save_fm_smart_link/`, "post", {
      id: release.id,
      fm_short_code: linkText.trim(),
      fm_artist_id: selectedArtist
    })
      .then((resp) => {
        if (resp && resp.data && resp.data.fm_smart_link_id) {
          toast.success(lang.catalog.smart_link.success.successful_smart_link_creation, successFilledToastOptions)
          setSmartLinkExist(true)
          setSelectedPage(SmartLinkPages.ANALYTICS)
        } else {
          toast.error(
            //@ts-ignore
            `${lang.catalog.smart_link.error[resp.data.message]}: ${linkText}`,
            errorFilledToastOptions
          )
        }
        setLoading(false)
      })
      .catch(() => {
        toast.error(lang.catalog.smart_link.error.error_on_smart_link_save, errorFilledToastOptions)
        setLoading(false)
      })
  }

  return (
    <div>
      <div style={{ height: `calc(100% - ${headerHeight * 2}px)` }} className="justify-center items-center flex">
        <div className="block" style={{ minWidth: 616 }}>
          <div>
            <KTitleSpan text={lang.catalog.smart_link.customize_title} fontSize={32} fontWeight={500} />
          </div>
          <div>
            <div style={{ width: "100%" }} className={`mt-6`}>
              <div className={`h-[64px] flex justify-between`}>
                <div className="flex" style={{ width: "100%" }}>
                  <img src={release.coverFileUrl} className={`w-[64px] h-[64px] rounded-[6px] cursor-pointer`} />
                  <div className="flex ml-6 justify-between" style={{ width: "100%" }}>
                    <div className="items-center flex" style={{ maxWidth: 330 }}>
                      <KTitleSpan text={release.title} fontSize={24} fontWeight={500} lineHeight="28px" />
                    </div>

                    <div className="flex gap-1 items-center ml-3">
                      {renderPill(release.artistsList.map((artist: Artist) => artist.name).join(", "))}
                      {renderPill(release.releaseDate || " - ")}
                      {renderPill(
                        `${release.totalTrack} ${
                          release.totalTrack > 1 ? lang.common.song_text_multi : lang.common.song_text_single
                        }`
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex justify-center items-center"></div>
              </div>
            </div>
          </div>
          <div className="mt-6">
            <KInput
              leftIcon="/account_icons/music-note-sparkle.svg"
              onChange={(text) => setLinkText(text)}
              value={linkText}
              placeholder={lang.catalog.smart_link.link_text_placeholder}
            />
          </div>
          <div className="mt-8">
            <KButton
              background="black"
              textColor="white"
              onClick={() => saveSmartLinkUrl()}
              text={lang.catalog.smart_link.save_changes_button}
              disabled={loading || !linkText || release.fmShortCode === linkText}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomizeLink
